import Footer from '@/renderer/Footer';
import Header from '@/renderer/Header';
import { usePageContext } from '@/renderer/utils/usePageContext';

export default ReleaseSchedulePage;

function ReleaseSchedule() {
  const {
    config: { title },
  } = usePageContext();

  return (
    <div className="flex h-40 min-h-[stretch] flex-1 grow flex-col justify-between overflow-hidden">
      <Header title="Release Schedule" className="py-2 sm:hidden" />
      <div className="overflow-auto">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="relative mx-auto hidden max-w-2xl pt-20 pb-24 text-center sm:block">
            <h1 className="font-bold text-3xl text-zinc-900 tracking-tight sm:text-4xl dark:text-zinc-200">
              {typeof title === 'string' ? title : ''}
            </h1>
            <p className="mt-4 text-base text-zinc-600 leading-7 dark:text-zinc-400">
              Last updated on Jan. 4, 2026
            </p>
          </div>
        </div>

        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="prose prose-sm prose-zinc dark:prose-invert mx-auto max-w-prose prose-a:font-semibold prose-a:hover:text-emerald-500">
            <p>Release windows are market dependent and release times may vary.</p>
            <div className="mt-8 space-y-16">
              <div>
                <h4 className="border-zinc-900/5 border-b font-bold text-zinc-500 uppercase dark:border-white/5 dark:text-zinc-400">
                  College basketball
                </h4>
                <div className="space-y-2">
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Weekday scheduled release</span>
                    </dt>
                    <dd className="p-0">9 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>
                        Weekend scheduled release
                        {/* <br />
                        <span className="font-normal">(totals, 1st halves & late sides)</span> */}
                      </span>
                    </dt>
                    <dd className="p-0 md:text-right">7:45 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Unplanned releases</span>
                    </dt>
                    <dd className="p-0">Rare, but possible throughout the day</dd>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8 space-y-16">
              <div>
                <h4 className="border-zinc-900/5 border-b font-bold text-zinc-500 uppercase dark:border-white/5 dark:text-zinc-400">
                  NFL
                </h4>
                <div className="space-y-2">
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span>Sides & Totals</span>
                    </dt>
                    <dd className="p-0">Mondays, 7:45-8:15 a.m. PT</dd>
                  </div>
                  <div className="flex flex-col items-start justify-between md:flex-row md:items-baseline">
                    <dt className="m-0 flex items-baseline space-x-2">
                      <span className="font-normal">
                        Additional updates throughout the week as needed. 10+ minute warning before
                        any release
                      </span>
                    </dt>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

// Main component
function ReleaseSchedulePage() {
  return <ReleaseSchedule />;
}
